import { useMemo } from "react";
import { useSelector } from "react-redux";

import { CURRENCIES, CURRENCY_MAP } from "../../constants";
import { selectCurrentUser } from "../../store/reducers/user";
import { Currency } from "../../types/InvoiceTypes";

export const useAllowedChains = (currency: Currency) => {
  const { allowed_outgoing_chains } = useSelector(selectCurrentUser);
  const currencyType = CURRENCY_MAP[currency].type;

  return useMemo(() => {
    const chains = CURRENCIES
      // Take only currencies as the outgoing currency type
      .filter((currency) => currency.type === currencyType)
      // Get the chains allowed for each currency. Put it in an oject as key
      // to remove duplicates
      .reduce((currCurrency, { value }) => {
        const allowedChains = allowed_outgoing_chains
          ? allowed_outgoing_chains[value]
          : [];

        return {
          ...currCurrency,
          ...allowedChains?.reduce(
            (currChain, chain) => ({
              ...currChain,
              [chain]: chain,
            }),
            {}
          ),
        };
      }, {});

    return Object.keys(chains);
  }, [allowed_outgoing_chains, currencyType]);
};
